import { configureStore } from '@reduxjs/toolkit'
import AccountReducer from './slices/AccountSlice'
import WorkspaceReducer from './slices/WorkspaceSlice'
import ModelReducer from './slices/ModelSlice'
import ModelTypeReducer from './slices/ModelTypeSlice'
import UserReducer from './slices/UserSlice'
import WorkspacePriceReducer from './slices/WorkspacePriceSlice'
import ImageLabelReducer from './slices/ImageLabelSlice'
import MCPReducer from './slices/MCPSlice'
import WorkflowReducer from './slices/WorkflowSlice'
import WorkspaceActivityReducer from './slices/WorkspaceActivitySlice'

export const store = configureStore({
    reducer: {
        account: AccountReducer,
        workspace: WorkspaceReducer,
        model: ModelReducer,
        modeltype: ModelTypeReducer,
        workspaceprices: WorkspacePriceReducer,
        user: UserReducer,
        imagelabel: ImageLabelReducer,
        mcp: MCPReducer,
        workflows: WorkflowReducer,
        workspaceActivity: WorkspaceActivityReducer,
    },
})

